/**
 * Helper to construct CDN URLs for private assets (avatars, logos, project images)
 * These assets are stored in R2 private bucket and accessed via the CDN worker
 */

import { env } from "@papier/env/env-frontend";

export function getCdnUrl(imageKey: string | null | undefined): string | undefined {
  if (!imageKey) return undefined;

  // If it's already a full URL, a data URL, or a blob URL, return as is
  if (
    imageKey.startsWith("http://") ||
    imageKey.startsWith("https://") ||
    imageKey.startsWith("data:") ||
    imageKey.startsWith("blob:")
  ) {
    return imageKey;
  }

  // Remove leading slash if present
  const cleanKey = imageKey.startsWith("/") ? imageKey.slice(1) : imageKey;

  // Construct CDN URL from the key
  // ETags are handled automatically by the CDN for cache validation
  return `${env.VITE_CDN_PATH}/${cleanKey}`;
}

export function getUserAvatarUrl(imageKey: string | null | undefined): string | undefined {
  return getCdnUrl(imageKey);
}

export function getOrganizationLogoUrl(logoKey: string | null | undefined): string | undefined {
  return getCdnUrl(logoKey);
}

export function getProjectImageUrl(imageKey: string | null | undefined): string | undefined {
  return getCdnUrl(imageKey);
}
